import type { BasicMenuItemProps } from '@placer-ui/components';
import type { ParsedDataRow } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { detectColumnType } from 'features/my-zone/support-requests/components/support-requests-modals/utils/columns-matcher/columns-matcher';

export const TOOLTIP_MESSAGES = {
    SELECTED: 'This column is already selected',
    EMPTY: 'This column cannot be selected because it contains no data',
    INVALID_ZIP: 'Please select a column containing valid US ZIP codes (e.g., 12345 or 12345-6789)',
    INVALID_COORDINATES: 'Please select a column containing valid coordinates (e.g., 40.7128)',
} as const;

export const createTooltipProps = (message: string) => ({
    title: message,
    zIndex: 100000,
    offset: -12,
});

//TODO PLAC-62943 - return it after validation per column will be there
// const isValidZipCode = (value: string): boolean => {
//     return US_ZIP_CODE_REGEX.test(String(value).trim());
// };

const isValidCoordinate = (value?: string | null) => {
    if (!value) return true;

    const strValue = String(value).trim();
    if (strValue === '') return true;

    const coordinateRegex = /^-?\d+(\.\d+)?$/;
    const numValue = parseFloat(strValue);

    if (!coordinateRegex.test(strValue)) return false;

    return !isNaN(numValue) && Math.abs(numValue) <= 180;
};

export const validateColumn = (
    column: string,
    data: ParsedDataRow[],
): { isValid: boolean; tooltipMessage?: string } => {
    const columnType = detectColumnType(column);

    if (!columnType) return { isValid: true };

    const values = data
        .map((row) => {
            const value = row[column];
            return value === null || value === undefined ? value : String(value).trim();
        })
        .filter(Boolean);

    if (values.length === 0) {
        return { isValid: false, tooltipMessage: TOOLTIP_MESSAGES.EMPTY };
    }

    switch (columnType) {
        //TODO PLAC-62943 - return it after validation per column will be there
        // case 'zip_code': {
        //     const isValid = values.every(isValidZipCode);
        //     return {
        //         isValid,
        //         tooltipMessage: isValid ? undefined : TOOLTIP_MESSAGES.INVALID_ZIP,
        //     };
        // }
        case 'lat':
        case 'lng': {
            const isValid = values.every(isValidCoordinate);
            return {
                isValid,
                tooltipMessage: isValid ? undefined : TOOLTIP_MESSAGES.INVALID_COORDINATES,
            };
        }
        default:
            return { isValid: true };
    }
};

export const processColumnsValidation = (
    columns: string[],
    data: ParsedDataRow[],
    selectedValues: string[],
    emptyColumnsList: string[],
): BasicMenuItemProps[] => {
    return columns.map((column) => {
        const isSelected = selectedValues.includes(column);
        const isEmpty = emptyColumnsList.includes(column);

        const validation = validateColumn(column, data);
        const isDisabled = isSelected || isEmpty || !validation.isValid;

        let tooltipMessage = validation.tooltipMessage;
        if (isSelected) {
            tooltipMessage = TOOLTIP_MESSAGES.SELECTED;
        } else if (isEmpty) {
            tooltipMessage = TOOLTIP_MESSAGES.EMPTY;
        }

        return {
            label: column,
            value: column,
            isDisabled,
            tooltip: tooltipMessage ? createTooltipProps(tooltipMessage) : undefined,
        };
    });
};
